import { useField } from "formik";

import { GoogleAddressSelect } from "./GoogleAddressSelect";
import { GoogleAddressSelectProps, onSelectionChangeType } from "./types";
import {
  InputWrapper,
  InputWrapperProps,
} from "../../components/inputs/_assets/input-wrapper/InputWrapper";

interface Props
  extends Omit<GoogleAddressSelectProps, "onSelectionChange">,
    Omit<InputWrapperProps, "children"> {
  name: string;
  onSelectionChange: (
    value: google.maps.places.PlaceResult[] | undefined
  ) => void;
  region?: string;
}

/**
 * @deprecated use AddressTextFieldFormikField instead.
 */
export function GoogleAddressSelectField({
  name,
  span = "auto",
  testID = "google-address-select-field",
  onSelectionChange,
  value,
  ...props
}: Props) {
  const [field, meta, helpers] = useField(name);

  const handleOnSelectionChange = ({
    addressComponents,
    address,
  }: onSelectionChangeType) => {
    onSelectionChange(addressComponents); // used to auto fill address components
    helpers.setValue(address); // used to submit full formatted address field
  };

  return (
    <InputWrapper span={span} testID={testID}>
      <GoogleAddressSelect
        validationState={meta.touched && meta.error ? "invalid" : "valid"}
        errorMessage={meta.touched && meta.error}
        value={field.value}
        {...props}
        onChange={helpers.setValue}
        onBlur={() => helpers.setTouched(true)}
        onSelectionChange={handleOnSelectionChange}
        initialValue={value}
      />
    </InputWrapper>
  );
}
